import BackendService from './BackendService';

export default class PermissionService {
  static getCurrentUserPermissions() {
    return BackendService.get('/permissions');
  }

  static getRoles() {
    return BackendService.get('/permissions/roles');
  }
}
